export default class LoadMore
{

	constructor(id, params, result)
	{
		this.id = id
		this.params = params
		this.result = result
		this.$component = document.getElementById(this.id)

		this.count = 0
		this.$link = this.$component.querySelector('.js-load-more')
		this.$items = this.$component.querySelector('.js-items')
		this.navNum = this.$link.dataset.navNum
		this.navPageCount = this.$link.dataset.navPageCount
		this.navPageNomer = this.$link.dataset.navPageNomer
		this.navPageSize = this.$link.dataset.navPageSize
	}

	init()
	{
		document.addEventListener('DOMContentLoaded', () => {
            this.documentReady()
		})
	}

	documentReady()
	{
		this.initEventHandler()
	}

	initEventHandler()
	{
		this.$link.addEventListener('click', (e) => {
			e.preventDefault()
            this.click()
		})
	}

	click()
	{
		if (!this.count || this.count == 0) {
			this.count = this.navPageNomer
		}

		if (this.count < this.navPageCount) {
			BX.showWait(BX(`${this.id}-items`))
			this.count++
			let url = `?AJAX_LOAD_MORE=Y&PAGEN_${this.navNum}=${this.count}`
				// ,historyUrl = `?PAGEN_${this.navNum}=${this.count}`

			jQuery.post(url, {}, html => {
				this.$items.insertAdjacentHTML('beforeEnd', html)
				// history.pushState(null, null, historyUrl)

				if (this.count == this.navPageCount) {
					this.$link.remove()
				}

				BX.closeWait(BX(`${this.id}-items`))
			})
		}
	}

}
